export const addressDataQuery = `query GetAddressData ($postalCode: String!, $houseNumber: Int!, $houseNumberAddition:String) {
    addressData(postalCode: $postalCode, houseNumber: $houseNumber, houseNumberAddition: $houseNumberAddition) {
        houseNumber,
        houseNumberAddition,
        houseLetter,
        street,
        city,
        postalCode,
        constructionYear,
        homeType,
        propertyUseType,
        rebuildCost,
        consideredMonumentByOwner,
        houseSurfaceAreaSquareMeters,
        numberRooms,
        propertyOfInsured
        roofConstructionType,
        constructionOfRoof,
        wozAppraisalValue,
        volumeInCubicMeters,
        contentValueIndication,
        solarPanels,
        numberOfSolarPanels,
        constructionOfWalls
    }
}
`;
